import { render } from "./MdAvatar.vue?vue&type=template&id=165fa757&scoped=true&ts=true"
import script from "./MdAvatar.vue?vue&type=script&lang=ts"
export * from "./MdAvatar.vue?vue&type=script&lang=ts"

import "./MdAvatar.vue?vue&type=style&index=0&id=165fa757&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165fa757"]])

export default __exports__